import { batch } from 'react-redux';
import { actions as groupActions } from '@ff-scene-plugins/photo-prints-redux/slices/groupsSlice';
import { actions as photoActions, selectPhotoIdsByGroupId } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpThunk } from '@ff-scene-plugins/photo-prints-redux/store';

export const removeGroup = (groupId: string): PhotoPrintsPdpThunk => (dispatch, getState) => {

    const state = getState();
    const photoIds = selectPhotoIdsByGroupId(state, groupId);

    batch(() => {
        dispatch(groupActions.remove(groupId));
        dispatch(photoActions.removeMany(photoIds));
    });
};